

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import { StringLiteralLike } from "typescript";
import {Deserializable} from "./deserializable.model";

export class SystemNotice {

//  public system_automation_id?: number;
//   public system_automation_name?: string;  

//   public   system_automation_description?: string;  
//   public current_user_owner: number;
//   public current_user_client: number;
//   public current_user_agent: number;
//   public note_template_owner?: string;  
//   public note_template_client?: string;  
//   public note_template_agent?: string;  
//   public email_template_owner?: string;  
//   public email_template_client?: string;  
//   public email_template_agent?: string;  
//   public send_email?: number;
  
//   public send_email_agent?: number;
//   public send_email_client?: number;
//   public send_email_owner?: number;
//   public  send_email_owner_staff?: number;

//   public send_email_agent_subject?: string;  
//   public send_email_client_subject?: string;  
//   public send_email_owner_subject?: string; 
  



//   public send_note?: number;

//   public send_note_agent?: number;
//   public send_note_client?: number;
//   public send_note_owner?: number;
//   public send_note_agent_subject?: string;  
//   public send_note_client_subject?: string;  
//   public send_note_owner_subject?: string;  


//   public create_log?: number;
//   public run_another_action?: number;
//   public create_document_file?: number;
//   public run_subject_communitcation_create_file?: number;
//   public log_insert_meta?: string;  

//   public note_type_id_agent?: number;
//   public note_type_id_client?: number;
//   public note_type_id_owner?: number;



//   public run_data_sector_conditions?: number; 
//   public chosen_data_sector_id?: number;
//   // public system_conditions_array?: string;  

// public send_email_owner_user?: number;
// public send_email_owner_user_id?: number;

// system_automation_icon;
// system_automation_colour;
// public danger_scale?: number;
// updated_date?: any;
// updated_by?: number;

  /*


system_automation_icon
system_automation_colour
danger_scale
updated_date
updated_by

system_automation_description
current_user_owner
current_user_client
current_user_agent
note_template_owner
note_template_client
note_template_agent
email_template_owner
email_template_client
email_template_agent
send_email
send_note
create_log
run_another_action
create_document_file
run_subject_communitcation_create_file
log_insert_meta
  */

//   public doc_id?: number;
//   public doc_name?: string;
//   public doc_template_file?: string;
//   public sfdt_template_file?: string;
//   public doc_save_name?: string;
//   public doc_description?: string;
//   public subject_com_type_id?: number;
//   public brand_type_id?: number;
//   public email_subject_header?: string;
//   public email_template?: string;
//   public is_active?: number;
//   // if is of type affidavit court documents.
//   // new logic to handle all document and correspondece creation in system
//   public job_type_affidavit_type_id?: number;
//   public job_type_court_id?: number;
//   public job_type_location_id?: number;
//   public job_type_id?: number;
//   public job_type_document_type_id?: number;
//   public email_template_HTML?: string;
//   public send_to_invoice?: number;
//   public send_to_report?: number;
//   public send_to_report_user?: number;
//   public send_to_logins?: number;
//   public send_to_primary?: number;
//   public original_doc__file?: string;

//   // extras for angular
//   public newTemplateFileName: string;
//   public original_doc_file?: string;

//   public doc_notes?: string;
//   public templates_created_tested?: number;


id?: number;
title: string;
message?: string;
start_datetime?: string;
end_datetime?: string;
show_on_login?: any;
route_paths?: string;
active?: any;
created_at?: string;
show_to_user_levels_below?: string;
show_to_user_level_only?: string;
created_by?: number;
show_to_brands?: any;
show_to_users?: any;
description?: string;
show_as_modal?: any;
show_to_tfa_user?: any;
show_on_logout?: any;
colour?: string;
icon?: string;
/*


`show_to_tfa_user` tinyint(1) DEFAULT 0,
  `show_on_logout` tinyint(1) DEFAULT NULL,
  `colour` varchar(255) DEFAULT '#000',
  `icon` varchar(255) DEFAULT 'fa fa-terminal',

TABLE `system_notices` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `title` varchar(255) DEFAULT NULL,
  `message` text,
  `start_datetime` datetime DEFAULT NULL,
  `end_datetime` datetime DEFAULT NULL,
  `show_on_login` tinyint(1) DEFAULT '0',
  `route_paths` text,
  `active` tinyint(1) DEFAULT '1',
  `created_at` timestamp NOT NULL DEFAULT CURRENT_TIMESTAMP,
  `show_to_user_levels_below` int(11) DEFAULT NULL,
  `show_to_user_level_only` int(11) DEFAULT NULL,
  `created_by` int(11) DEFAULT NULL,
  `show_to_brands` text,
  `show_to_users` text,
  `description` text,
  `show_as_modal` tinyint(1) DEFAULT '0',
  PRIMARY KEY (`id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8

*/







  // ? what does this really do? (no encoding or deserialisation required...)
//   deserialize(input: any): SystemNotice {
//     Object.assign(this, input);

//     return this;
//   }


}

  // Set the Stats
